import { render, staticRenderFns } from "./teamCard.vue?vue&type=template&id=76cffa0e&scoped=true"
import script from "./teamCard.vue?vue&type=script&lang=js"
export * from "./teamCard.vue?vue&type=script&lang=js"
import style0 from "./teamCard.vue?vue&type=style&index=0&id=76cffa0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cffa0e",
  null
  
)

export default component.exports